import { dialApiFetch, isDialApiConfigured } from './client';

export interface LeaderboardEntry {
  user_id: string;
  label: string;
  points_today: number;
  rank: number;
}

export interface LeaderboardResponse {
  top: readonly LeaderboardEntry[];
  me: LeaderboardEntry;
  points_to_next_rank: number | null;
  day_start: string;
  campaign_id: string | null;
}

function demo(campaignId: string | null): LeaderboardResponse {
  return {
    top: [
      { user_id: 'demo-tom', label: 'Tom', points_today: 18, rank: 1 },
      { user_id: 'demo-susan', label: 'Susan', points_today: 14, rank: 2 },
      { user_id: 'demo-greg', label: 'Greg', points_today: 11, rank: 3 },
    ],
    me: { user_id: 'demo-me', label: 'You', points_today: 7, rank: 6 },
    points_to_next_rank: 2,
    day_start: new Date(new Date().setUTCHours(0, 0, 0, 0)).toISOString(),
    campaign_id: campaignId,
  };
}

export async function getLeaderboard(campaignId?: string | null): Promise<LeaderboardResponse> {
  if (!isDialApiConfigured) return demo(campaignId ?? null);
  const qs = campaignId ? `?campaign_id=${encodeURIComponent(campaignId)}` : '';
  return dialApiFetch<LeaderboardResponse>(`/v1/leaderboard${qs}`);
}
